export default __webpack_public_path__ + "static/media/a024-startup-6.732982eb.svg";